/**
 * 從地址字串中只取出「縣市 + 行政區」層級
 * 例：「台北市大安區和平東路二段123號」→「台北市大安區」
 */
export function trimToDistrict(location: string): string {
  if (!location) return location;
  // 匹配 縣市 + 區鄉鎮市
  const match = location.match(/[\u4e00-\u9fa5]{2,4}[市縣][\u4e00-\u9fa5]{2,4}[區鄉鎮市]/);
  if (match) return match[0];
  // fallback: 只取縣市
  const cityMatch = location.match(/[\u4e00-\u9fa5]{2,4}[市縣]/);
  if (cityMatch) return cityMatch[0];
  return location;
}

/**
 * 遮蔽姓名，只顯示第一個字 + **
 * 例：「蔡小明」→「蔡**」、「王大」→「王*」
 */
export function maskName(name: string): string {
  if (!name) return name;
  if (name.length <= 1) return name;
  return name[0] + '*'.repeat(Math.min(name.length - 1, 2));
}

/**
 * 遮蔽電話號碼，只保留前4碼與後3碼
 * 例：「0912345678」→「0912-***-678」
 *     「0223456789」→「02-***-789」
 */
export function maskPhone(phone: string): string {
  if (!phone) return phone;
  const cleaned = phone.replace(/[-\s]/g, '');
  if (cleaned.length <= 4) return cleaned;
  const front = cleaned.slice(0, 4);
  const back = cleaned.slice(-3);
  return `${front}-***-${back}`;
}

/**
 * 計算上架天數文字
 * 例：0天→「今天剛上架」、1天→「昨天上架」、5天→「5 天前上架」、35天→「1 個月前上架」
 */
export function daysAgoText(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) return '今天剛上架';
  if (diffDays === 1) return '昨天上架';
  if (diffDays < 30) return `${diffDays} 天前上架`;
  const months = Math.floor(diffDays / 30);
  return `${months} 個月前上架`;
}
